/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
// Shared functionality among backends.
export { simpleAbsImpl } from './kernels/Abs';
export { addImpl } from './kernels/Add';
export { bincountImpl, bincountReduceImpl } from './kernels/Bincount_impl';
export { ceilImpl } from './kernels/Ceil';
export { concatImpl } from './kernels/Concat_impl';
export { expImpl } from './kernels/Exp';
export { expm1Impl } from './kernels/Expm1';
export { floorImpl } from './kernels/Floor';
export { gatherV2Impl } from './kernels/GatherV2_impl';
export { greaterImpl } from './kernels/Greater';
export { lessImpl } from './kernels/Less';
export { linSpaceImpl } from './kernels/LinSpace_impl';
export { logImpl } from './kernels/Log';
export { maxImpl } from './kernels/Max_impl';
export { maximumImpl } from './kernels/Maximum';
export { minimumImpl } from './kernels/Minimum';
export { multiplyImpl } from './kernels/Multiply';
export { negImpl } from './kernels/Neg';
export { notEqualImpl } from './kernels/NotEqual';
export { prodImpl } from './kernels/Prod';
export { rangeImpl } from './kernels/Range_impl';
export { rsqrtImpl } from './kernels/Rsqrt';
export { sliceImpl } from './kernels/Slice';
export { squaredDifferenceImpl } from './kernels/SquaredDifference';
export { stridedSliceImpl } from './kernels/StridedSlice_impl';
export { subImpl } from './kernels/Sub';
export { tileImpl } from './kernels/Tile_impl';
export { topKImpl } from './kernels/TopK_impl';
export { transposeImpl } from './kernels/Transpose_impl';
export { uniqueImpl } from './kernels/Unique_impl';
//# sourceMappingURL=shared.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tensorflow/tfjs-backend-cpu/dist/shared.js
// module id = 486
// module chunks = 0